import React from "react";

function Logo() {
  return <div className="logo"> Huh what's this </div>;
}

export default Logo;
